<div class="app-radio-button form-group" [ngClass]="[classGroup]">
  <div class="custom-control custom-radio" [ngClass]="{ 'is-sm': isSm }">
    <input
      *ngIf="controlPresented"
      type="radio"
      class="custom-radio-input"
      [id]="id"
      [name]="name"
      [formControl]="control"
      [value]="value"
      [attr.disabled]="disabled ? true : undefined"
    />

    <input
      *ngIf="modelPresented"
      type="radio"
      class="custom-radio-input"
      [id]="id"
      [name]="name"
      [ngModel]="modelField"
      [value]="value"
      [attr.disabled]="disabled ? true : undefined"
      (ngModelChange)="modelChanged.emit($event)"
    />
    <ng-template [ngIf]="tooltipData" [ngIfElse]="noTooltip">
      <label class="custom-control-label" [for]="id">
        <ng-content select="[labelInner]"></ng-content>
        {{ label | translate }}

        <app-hint-tooltip-icon [hint]="tooltipData | translate"></app-hint-tooltip-icon>
      </label>
    </ng-template>
    <ng-template #noTooltip>
      <label class="custom-control-label" [for]="id">
        <ng-content select="[content]"></ng-content>
        <span [innerHTML]="label | translate" [ngClass]="{ 'without-label': hideLabel }"></span>
        <ng-content select="[content-after]"></ng-content>
      </label>
    </ng-template>
    <div class="helper-form-control" *ngIf="helper" [innerHTML]="helper | translate"></div>
  </div>
</div>
